import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from '../modal.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NavigateService, } from 'src/app/services/navigate/navigate.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { config } from 'src/app/app.config';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-switch-account-modal',
  templateUrl: './switch-account-modal.component.html',
  styleUrls: ['./switch-account-modal.component.scss']
})
export class SwitchAccountModalComponent implements OnInit {
  @ViewChild('accountModal', { static: true })
  accountModal!: TemplateRef<any>;

  modalRef: BsModalRef;
  accountList: any[] = [];
  myProfile: any = {};
  profileImage: any;
  
  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private navigate: NavigateService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private utility: UtilitysService,
  ) { }
private destroy$ = new Subject<void>();
  async ngOnInit() {
    // preload data
    await this.getProfile();
    this.api.getAccountList().subscribe(res => {
      if (res.Code === 200) {
        this.accountList = res.Results;
      }
    });

    this.modalServ.onOpenAccountList
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.modalRef = this.modalService.show(this.accountModal, {
          class: 'modal-dialog-centered modal-dialog-scrollable'
        });
      });
  }

  ngOnDestroy() {
   this.destroy$.next();
    this.destroy$.complete();
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.modalRef = null;
    }
  }


  onSwitchAccount(userId: any, empId: any) {
    this.closeModal();
    var userlist = JSON.parse(localStorage.getItem("userList")) || {};
    if (!userlist[userId]) {
      this.navigate.navigateMenu('signin?step=add-account-again&user=' + empId + '&refresh=false');
    }
    else {
      // this.signout();
      this.ngxUiLoaderService.start();
      this.api.getMyProfile2(userId).subscribe(res => {
        if (res.Code == 200) {
          // this.imgAvatar = res.Results ;
          this.setCredentials(userlist[userId]);
          this.ngxUiLoaderService.stopAll();
          setTimeout(() => {
            this.navigate.navigateMenu('home', true);
          }, 0);
        }
        else {
          this.ngxUiLoaderService.stopAll();
          this.navigate.navigateMenu('signin?step=add-account-again&user=' + empId + '&refresh=true');
        }
      });
      // this.getProfile(true, empId);
      // this.navigate.navigateMenu('home', true);
      // window.location.reload();
    }


  }

  setCredentials(res: any) {
    window.localStorage.setItem(config.baseURL + '/tokenType', res["tokenType"]);
    window.localStorage.setItem(config.baseURL + '/accessToken', res["accessToken"]);
    window.localStorage.setItem(config.baseURL + '/token', res["token"]);
    window.localStorage.setItem(config.baseURL + '/type', res["type"]);
  }

  async getProfile(isSwitchAccount = false, selectedEmpId = '') {
    this.ngxUiLoaderService.start();
    try {
      this.myProfile = await this.utility.getMyProfile();
      if (isSwitchAccount) {
        this.navigate.navigateMenu('home', true);
      }
    } catch (error) {
      console.error("Error loading profile:", error);
      if (isSwitchAccount) {
        this.navigate.navigateMenu('signin?step=add-account-again&user' + selectedEmpId);
      }
    }
    this.ngxUiLoaderService.stopAll();
    this.profileImage = this.myProfile.AvatarURL;

  }

  gotoAddAccount() {
    this.closeModal();
    this.navigate.navigateMenu('signin?step=add-account');
  }


}
